import { Link } from 'react-router-dom';
import FaqAccordion from '@/components/feature/FaqAccordion';
import { faqs } from '@/mocks/content';

export default function FaqPreviewSection() {
  const preview = faqs.slice(0, 4);

  return (
    <section className="border-b border-background-200 bg-background-100">
      <div className="w-full px-4 py-14 md:px-8 md:py-16">
        <div className="grid grid-cols-1 gap-10 lg:grid-cols-12">
          <div className="lg:col-span-4">
            <p className="text-xs uppercase tracking-[0.25em] text-primary-600">FAQ</p>
            <h2 className="mt-2 font-heading text-2xl font-bold text-foreground-950 md:text-3xl">
              你可能想问的
            </h2>
            <p className="mt-4 text-sm leading-relaxed text-foreground-600">
              关于内容来源、信息状态标签、讨论区规则和版权处理，我们把常见疑问整理在了一起。
            </p>
            <Link
              to="/faq"
              className="mt-6 inline-flex whitespace-nowrap items-center gap-1 border border-background-300 bg-background-50 px-4 py-2 text-sm text-foreground-700 transition-colors hover:border-primary-400 hover:text-primary-600"
            >
              查看全部问题 <i className="ri-arrow-right-line" aria-hidden="true" />
            </Link>
          </div>
          <div className="lg:col-span-8">
            <FaqAccordion items={preview} defaultOpenId={preview[0]?.id} />
          </div>
        </div>
      </div>
    </section>
  );
}